const reportWebVitals = (onPerfEntry) => {
  if (typeof onPerfEntry !== "function") return;
  import("web-vitals").then(({ onCLS, onFCP, onINP, onLCP, onTTFB }) => {
    [onCLS, onFCP, onINP, onLCP, onTTFB].forEach((observe) => observe(onPerfEntry));
  });
};

export default reportWebVitals;
